import { useCallback, useState } from "react";

export type IValue = number[];
export type TSetServices = (value: IValue) => void;
export type TChangeService = (codes: IValue) => void;

export interface ServiceState extends IValue {}

interface Result {
  services: ServiceState;
  onChangeServices: TChangeService;
  setServices: TSetServices;
}
type UseServicesState = (initValue?: ServiceState) => Result;

export const useServicesState: UseServicesState = (initValue?: number[]) => {
  const [services, setServices] = useState(() => initValue || []);

  const onChangeServices = useCallback(
    (codes: IValue) => setServices(codes),
    []
  );

  return {
    services,
    onChangeServices,
    setServices,
  };
};
